<fieldset>
    <div class="fixed-section">
        <section class="titleBarBg fixed-top">
            <div class="container-fluid">
                <div class="row mar-7px">
                    <div class="w-3">
                        <img src="assets/images/groupuser_wt.png" class="pageIcon" alt="" style="height: 38px;">
                    </div>
                    <div class="w-97">
                        <div class="pageHeadingBar">
                            <div class="row">
                                <div class="col-md-6 align-self-center">
                                    <h6 class="pageHeadingText mb-0 text-uppercase">ACCESS/USER MANAGEMENT</h6>
                                </div>
                                <div class="col-md-3 align-self-center">
                                </div>
                                <div class="col-md-3 align-self-center text-end">
                                    <ul class="list-inline mb-0">
                                        <li class="list-inline-item">
                                            <img *ngIf="disableExportUsersListAction" src="assets/images/loader_btn.gif"
                                                class="buttonsmallIcon mr-2" alt="Loader">

                                            <img src="assets/images/export.png" class="me-1 w-25px pointerCursor"
                                                alt="Export" title="Export"
                                                [class.disabled]="disableExportUsersListAction"
                                                (click)="!disableExportUsersListAction && exportUsersList()">

                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <div class="middleContent mt-131">
        <section class="mt-131">
            <div class="container-fluid px-2">
                <div class="row">
                    <div class="col-md-3 border-right-solid" [ngClass]="{'disabled-div': !isEditUserRoles}">
                        <div class="row">
                            <div class="col-md-3 mb-3">
                                <label>Name</label>
                            </div>
                            <div class="col-md-9 mb-3">
                                <span style="font-weight:bold">{{selectedUserName}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3 mb-3">
                                <label>Email</label>
                            </div>
                            <div class="col-md-9 mb-3">
                                <span style="font-weight:bold">{{selectedUserEmail}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label>Select Roles</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group">
                                <div class="checkbox-container">
                                    <div class="col-md-12 mb-3">
                                        <ng-container>
                                            <input class="form-check-input ml-2 large-checkbox mt-0 me-2"
                                                type="checkbox" [attr.id]="'checksreadmin_' + selectedUserId"
                                                [(ngModel)]="isSREAdmin" [ngModel]="isSREAdmin" />
                                            <label class="form-check-label ml-2"
                                                [attr.for]="'checksreadmin_' + selectedUserId">ISO Admin</label>
                                        </ng-container>
                                    </div>
                                    <div class="col-md-12 mb-4">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <ng-container>
                                                    <input class="form-check-input ml-2 large-checkbox mt-0 me-2"
                                                        type="checkbox"
                                                        [attr.id]="'isCustomerSupportTeam_' + selectedUserId"
                                                        [(ngModel)]="isCustomerSupportTeam"
                                                        [ngModel]="isCustomerSupportTeam" />
                                                    <label class="form-check-label ml-2"
                                                        [attr.for]="'isCustomerSupportTeam_' + selectedUserId">Customer
                                                        Support</label>
                                                </ng-container>
                                            </div>
                                            <div class="col-md-6 me-8"
                                                [ngClass]="{'disabled-div': !isCustomerSupportTeam}">
                                                <p-multiSelect [options]="categories" optionLabel="name"
                                                    optionValue="code" [(ngModel)]="selectedCategories"
                                                    placeholder="Select category" (click)="stopPropagation($event)"
                                                    class="mr-4 multicategories">
                                                    <ng-template pTemplate="header">
                                                        <div class="custom-multiselect-header">
                                                            <span style="padding-right: 5px;">SELECT ALL</span>
                                                        </div>
                                                    </ng-template>
                                                </p-multiSelect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 text-end">
                                        <div *ngIf="selectedUserApprovalStatus == 'PENDING'" class="me-4">
                                            <button class="btn btn-sm executionStart me-1 mt-2 w-25"
                                                data-bs-toggle="modal"
                                                (click)="approveOrRejectApprovalStatus(selectedUser, true)"
                                                [disabled]="!isEditUserRoles">APPROVE</button>
                                            <button class="btn btn-sm executionStart mt-2 w-25" data-bs-toggle="modal"
                                                (click)="approveOrRejectApprovalStatus(selectedUser, false)"
                                                [disabled]="!isEditUserRoles">REJECT</button>
                                        </div>
                                        <div *ngIf="selectedUserApprovalStatus !== 'PENDING'" class="me-4">
                                            <button class="btn btn-sm executionStart me-1 mt-2 w-25"
                                                data-bs-toggle="modal"
                                                (click)="approveOrRejectApprovalStatus(selectedUser, true)"
                                                [disabled]="!isEditUserRoles">UPDATE USER</button>
                                            <button class="btn btn-sm executionStart mt-2 w-25" data-bs-toggle="modal"
                                                (click)="cancelUserDetails()"
                                                [disabled]="!isEditUserRoles">CANCEL</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9">
                        <div class="row pt-1">
                            <div class="col-md-2">
                                <span *ngIf="allUsersWithoutDeleted.length > 0" class="totalUserSpan">User(s) Count: {{
                                    filteredUsers.length }} </span>
                            </div>
                            <div class="col-md-5"></div>
                            <div class="col-md-4 position-relative">
                                <input type="text" class="form-control" placeholder="SEARCH BY NAME OR EMAIL"
                                    [(ngModel)]="searchTerm" (keyup)="filterUsers()">
                                <img src="assets/images/magnifying-glass.png" placeholder="Type Project Title to Filter"
                                    class="searchIcon" alt="" (click)="filterUsers()">
                            </div>
                            <div class="col-md-1 align-self-center text-center">
                                <div class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle urserName" href="#" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="true">
                                        <img src="assets/images/filter.png" class="me-0 w-20" alt="" title="Filter">
                                    </a>
                                    <ul class="dropdown-menu customMargindrpaccess" data-popper-placement="bottom-end"
                                        style="position: absolute; inset: 0px 0px auto auto; margin: 0px; transform: translate3d(0.8px, 24.8px, 0px);">
                                        <div class="row mb-12px">
                                            <div class="col-md-5">
                                                <label>Role</label>
                                            </div>
                                            <div class="col-md-7">
                                                <select class="form-select border-0" aria-label="Default select example"
                                                    [(ngModel)]="selectedUserRole">
                                                    <option value="0">Select Role</option>
                                                    <option *ngFor="let role of userFilterRoles" [value]="role.value">
                                                        {{ role.label }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row mb-12px">
                                            <div class="col-md-5">
                                                <label>Category</label>
                                            </div>
                                            <div class="col-md-7">
                                                <p-multiSelect [options]="categories" optionLabel="name"
                                                    optionValue="name" [(ngModel)]="selectedFilterCategories"
                                                    placeholder="Select category" (click)="stopPropagation($event)"
                                                    class="mr-4 multicategories wide-multiselect">
                                                    <ng-template pTemplate="header">
                                                        <div class="custom-multiselect-header">
                                                            <span style="padding-right: 5px;">SELECT ALL</span>
                                                        </div>
                                                    </ng-template>
                                                </p-multiSelect>
                                            </div>
                                        </div>
                                        <div class="row mb-12px">
                                            <div class="col-md-5">
                                                <label>Access Status</label>
                                            </div>
                                            <div class="col-md-7">
                                                <select class="form-select border-0" aria-label="Default select example"
                                                    [(ngModel)]="selectedApprovalStatus"
                                                    (ngModelChange)="onApprovalStatusChange($event)">
                                                    <option value="0">Select Access Status</option>
                                                    <option *ngFor="let status of approvalStatuses"
                                                        [value]="status.value">
                                                        {{ status.label }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row mb-12px">
                                            <div class="col-md-5">
                                                <label>Retail Hub Status</label>
                                            </div>
                                            <div class="col-md-7">
                                                <select class="form-select border-0" aria-label="Default select example"
                                                    [(ngModel)]="selectedUserStatus"
                                                    [disabled]="isRetailHubStatusDisabled()">
                                                    <option value="0">Select User Status</option>
                                                    <option *ngFor="let status of userStatuses" [value]="status.value">
                                                        {{ status.label }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row ">
                                            <div class="offset-md-3 col-md-9">
                                                <button type="button" (click)="onApplyFilter();"
                                                    class="btn progressBtn ps-2 w-100">APPLY FILTER
                                                </button>
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="table-responsive tableFixHead mt-3">
                                    <table class="table datatable border-x-0 mb-0">
                                        <thead>
                                            <tr class="subheaderrr">
                                                <th scope="col" class="text-start py-2" width="12%">Name</th>
                                                <th scope="col" class="text-start py-2" width="18%">Email</th>
                                                <th scope="col" class="text-start py-2" width="17%">Role</th>
                                                <th scope="col" class="text-start py-2" width="18%">Category</th>
                                                <th scope="col" class="text-start py-2" width="15%">Access Status</th>
                                                <th scope="col" class="text-start py-2" width="12%">Retail Hub Status
                                                </th>
                                                <th scope="col" class="text-start py-2" width="8%">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of filteredUsers">
                                                <td class="vertical-align-middle">
                                                    {{item.firstname}} {{item.lastname}}
                                                </td>
                                                <td class="vertical-align-middle">
                                                    {{item.userEmail}}
                                                </td>
                                                <td class="vertical-align-middle">
                                                    {{ item.selectedRoles | roleDisplay | uppercase }}
                                                </td>
                                                <td class="vertical-align-middle">
                                                    <span
                                                        *ngIf="shouldShowCategories(item.selectedRoles, item.selectedCategories)">
                                                        {{ item.selectedCategories }}
                                                    </span>
                                                </td>
                                                <td style="text-align:center">
                                                    <!-- <div *ngIf="item.status == 'PENDING'">
                                                        <button type="button" class="btn btn-outline-success me-2" (click)="approveOrRejectApprovalStatus(item, true)">APPROVE</button>
                                                        <button type="button" class="btn btn-outline-danger w-123" (click)="approveOrRejectApprovalStatus(item, false)">REJECT</button>
                                                    </div>
                                                    <span *ngIf="item.status !== 'PENDING'" [ngClass]="{
                                                                            'status-approved': item.status === 'APPROVED',
                                                                            'status-rejected': item.status === 'REJECTED'
                                                                    }">
                                                        {{ item.status }}
                                                    </span> -->
                                                    <span [ngClass]="{
                                                                                'status-approved': item.status === 'APPROVED',
                                                                                'status-rejected': item.status === 'REJECTED',
                                                                                'status-pending': item.status === 'PENDING'
                                                                        }">
                                                        {{ item.status }}
                                                    </span>
                                                </td>
                                                <td
                                                    [ngClass]="{'disabled-row': item.status === 'PENDING' || item.status === 'REJECTED'}">
                                                    <div class="activeDesablebtn alignitemss"
                                                        *ngIf="item.status !== 'PENDING' && item.status !== 'REJECTED'">
                                                        <div class="toggle-button-cover">
                                                            <div class="button-cover">
                                                                <div class="button b2" id="button-15">
                                                                    <input type="checkbox" class="checkbox"
                                                                        [checked]="item.isActive"
                                                                        (change)="enableOrDisableUserStatus($event, item)">
                                                                    <div class="knobs">
                                                                        <span></span>
                                                                    </div>
                                                                    <div class="layer"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style="text-align:center">
                                                    <img src="assets/images/pencilIocn.svg" title="Edit" alt=""
                                                        class="pointer-icon" (click)="editUserDetails(item)"
                                                        *ngIf="!(!item.isActive && item.status === 'REJECTED')" />
                                                    <img src="assets/images/close_mark.svg" title="Delete" alt=""
                                                        class="pointer-icon" style="height:20px;width:23px;"
                                                        (click)="deleteUserDetails(item)" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="card" *ngIf="filteredUsers.length === 0 ">
                                        <div class="card-body py-2 px-3">
                                            <div class="emtyCard p-0">
                                                <p class="mb-0">No Records Found
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</fieldset>

<p-confirmDialog position="top" [baseZIndex]="200000" appendTo="body" role="alertdialog"></p-confirmDialog>